import type { ConsolaLogger, ConsolaOptions, Log, LogOptions } from '../types';

/**
 * Manages the console logger reporters.
 */
class Consola implements ConsolaLogger {
  private options = new Map<string, ConsolaOptions>();

  setLogger(namespace: string, options: ConsolaOptions): void {
    this.options.set(namespace, options);

    const [reporter] = options.reporters;
    const { title } = reporter?.getOptions() || {};
    const { B2X_VERSIONS = {} } = window || {};

    if (!B2X_VERSIONS?.[namespace] && title) {
      Object.assign(window, { B2X_VERSIONS: { [namespace]: title, ...B2X_VERSIONS } });
    }
  }

  getLogger(namespace: string): Log {
    const { reporters = [] } = this.options.get(namespace) || {};
    const log = (message: string, options: LogOptions) => {
      const date = new Intl.DateTimeFormat(['pt-PT', 'de-DE', 'en-GB'], {
        year: 'numeric',
        month: '2-digit',
        day: '2-digit',
        hour: '2-digit',
        minute: '2-digit',
        second: '2-digit',
      }).format(Date.now());

      for (const reporter of reporters) {
        reporter.report(message, { ...options, date });
      }
    };

    return log;
  }

  createLoggerGroup(namespace: string, group: string) {
    const { reporters = [] } = this.options.get(namespace) || {};

    return {
      info: (message: string, ...args: any[]) => {
        for (const reporter of reporters) {
          reporter.reportInfo(message, group, ...args);
        }
      },
      warn: (message: string, ...args: any[]) => {
        for (const reporter of reporters) {
          reporter.reportWarning(message, group, ...args);
        }
      },
      error: (message: string, ...args: any[]) => {
        for (const reporter of reporters) {
          reporter.reportError(message, group, ...args);
        }
      },
    };
  }
}

function initConsola(): ConsolaLogger {
  return new Consola();
}

/**
 * Manages the console reporters.
 */
const consola = initConsola();

export { consola };
